import React from "react";

import TypingEffect from "../utils/typing-effect/TypingEffect";
import { ThemedIcon } from "@me8eon/icons";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";

const ragComponent: React.FC<MessageWithActionAndData> = ({
    content
}: MessageWithActionAndData) => {
    return (
        <div className="bot-header">
            <div className="eon-logo">
                <ThemedIcon name={"AiIcon"} />
            </div>
            <div className="bot-reply-container">
                <TypingEffect className="bot-text" text={content} speed={1} />
            </div>
        </div>
    );
};

export default ragComponent;
